var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 32,
    fill: "#E84E57"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.25 37.5H63C56.6994 37.5 53.5491 37.5 51.1426 38.7262C49.0258 39.8048 47.3048 41.5258 46.2262 43.6426C45 46.0491 45 49.1994 45 55.5V94.5C45 100.801 45 103.951 46.2262 106.357C47.3048 108.474 49.0258 110.195 51.1426 111.274C53.5491 112.5 56.6994 112.5 63 112.5H87C93.3006 112.5 96.4509 112.5 98.8574 111.274C100.974 110.195 102.695 108.474 103.774 106.357C105 103.951 105 100.801 105 94.5V56.25L86.25 37.5ZM82.5 43.125V57C82.5 58.0501 82.5 58.5751 82.7044 58.9762C82.8841 59.329 83.171 59.6159 83.5238 59.7956C83.9249 60 84.4499 60 85.5 60H99.375L82.5 43.125ZM60 60C57.9289 60 56.25 61.6789 56.25 63.75C56.25 65.8211 57.9289 67.5 60 67.5H63.75C65.8211 67.5 67.5 65.8211 67.5 63.75C67.5 61.6789 65.8211 60 63.75 60H60ZM60 75C57.9289 75 56.25 76.6789 56.25 78.75C56.25 80.8211 57.9289 82.5 60 82.5H90C92.0711 82.5 93.75 80.8211 93.75 78.75C93.75 76.6789 92.0711 75 90 75H60ZM60 90C57.9289 90 56.25 91.6789 56.25 93.75C56.25 95.8211 57.9289 97.5 60 97.5H90C92.0711 97.5 93.75 95.8211 93.75 93.75C93.75 91.6789 92.0711 90 90 90H60Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsIconRed);
export default __webpack_public_path__ + "static/media/news_icon_red.9faf7ae55033dfac58e049126ee6824c.svg";
export { ForwardRef as ReactComponent };